import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { take } from 'rxjs/operators';
import { FileInfoInterface } from 'src/app/model/marketplace/file-info-interface';
import { FileServiceService } from 'src/app/services/file-service/file-service.service';

@Component({
    selector: 'app-product-files',
    templateUrl: './product-files.component.html',
    styleUrls: ['./product-files.component.css'],
    standalone: false
})
export class ProductFilesComponent implements OnInit {
    @Input() documentFileIds: string[];
    @Input() galleryFileIds: string[];
    @Input() logoId: string;
    @Input() galleryTitle: string = 'Produktgalerie';
    @Output() logoChanged = new EventEmitter<string>();

    documentFileInfosById: Map<string, any>;

    constructor(
        private fileService: FileServiceService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.setDocumentFileInfos();
    }

    private setDocumentFileInfos() {
        this.fileService
            .getMetaDataForFiles(this.documentFileIds)
            .pipe(take(1))
            .subscribe((fileInfos) => {
                this.documentFileInfosById = new Map<
                    string,
                    FileInfoInterface
                >();
                for (const fileInfo of fileInfos) {
                    this.documentFileInfosById.set(fileInfo.id, fileInfo);
                }
                this.cd.detectChanges();
            });
    }

    setNewFileIds(target: string, fileIds: string[]) {
        if (target == 'Galerie') {
            this.addFileIdsIfNew(this.galleryFileIds, fileIds);
        } else if (target == 'Dokumente') {
            this.addFileIdsIfNew(this.documentFileIds, fileIds);
            this.setDocumentFileInfos();
        }
        this.cd.detectChanges();
    }

    private addFileIdsIfNew(
        previousFileIds: string[],
        currentFileIds: string[]
    ) {
        currentFileIds.forEach((fileId) => {
            if (!previousFileIds.includes(fileId)) {
                previousFileIds.push(fileId);
            }
        });
    }

    getNameOfDocument(id: string): string {
        if (this.documentFileInfosById && this.documentFileInfosById.has(id)) {
            return this.documentFileInfosById.get(id).filename;
        }
        return '';
    }

    removeDocument(index: number): void {
        this.documentFileIds.splice(index, 1);
    }

    moveUpDocument(index: number): void {
        this.moveItemInFileList(this.documentFileIds, index, index - 1);
    }

    moveItemInFileList(
        fileList: string[],
        startIndex: number,
        endIndex: number
    ) {
        if (
            fileList == null ||
            startIndex < 0 ||
            startIndex >= fileList.length ||
            endIndex < 0 ||
            endIndex >= fileList.length
        ) {
            return;
        }
        const movedElement = fileList[startIndex];
        fileList.splice(startIndex, 1);
        fileList.splice(endIndex, 0, movedElement);
    }

    moveDownDocument(index: number): void {
        this.moveItemInFileList(this.documentFileIds, index, index + 1);
    }

    getFilePath(fileId: string): string {
        return `/proxy/api/v0/fileservice/file/${fileId}`;
    }

    moveGalleryFileUp(index: number): void {
        this.moveItemInFileList(this.galleryFileIds, index, index - 1);
    }

    moveGalleryFileDown(index: number): void {
        this.moveItemInFileList(this.galleryFileIds, index, index + 1);
    }

    removeGalleryImage(index: number): void {
        this.galleryFileIds.splice(index, 1);
    }
}
